import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useState } from 'react'
import styles from './../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import textStyles from './../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext'
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp'
import TemplateDetailsComponent from '../../../../manyChat/workFlowFormComponents/templateDetails/templateDetailsComponent'
import { WorkflowContext, WorkflowContextPayload } from '../../../../../context/workflowContext'
import { isCarouselTemplateActionType, isSendOrderDetailTemplateActionType } from '../../utilityFunctions'

const TemplateFormComponent = (props: any) => {
    const { handleBodyTitle, actionData, stepAction } = props;
    const [flagTemplatePopup, setFlagTemplatePopup] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');
    const [tempActionData, setTempActionData] = useState(actionData);
    const { nodes, setTempNodesTemplate, onChangeCurrentActiveNodeConfig, tempNodesTemplate, currentActiveNodeConfig,  } = useContext(FlowBuilderContext) as FlowBuilderContextPayload
    const { currentActiveStaticWorkflow } = useContext(WorkflowContext) as WorkflowContextPayload

    const getMetaIntegrationWhatsAppId = (whatsapp_template_id: number | string) => {
        const currentSelectedTemplate = currentActiveStaticWorkflow?.additional_data?.whatsapp_templates?.find((template) => Number(template?.whatsapp_template_id) == Number(whatsapp_template_id)); 
        if(currentSelectedTemplate){
            return currentSelectedTemplate?.meta_integration_whatsapp_id || "";
        }
        return "";
    }
    
    return (
        <Grid item>
            <Grid container direction={"column"} gap={"12px"}>
                {/* <Grid item className={styles.bodyFormHeadingStyle}>
                    {handleBodyTitle('message')}
                </Grid> */}

                <Grid item mt={2} className={textStyles.templatesContainer}>
                    <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                        <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                            {isCarouselTemplateActionType(stepAction?.action_type?.action_type_name) ? 'Carousel ' : isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) && 'Send Order Detail '}Message Template
                        </Grid>
                        <Grid item className={styles.contentBlockSubHeadingStyle} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                            <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                <Grid item sx={{ wordBreak: "break-word" }}>
                                    {actionData.whatsapp_template.whatsapp_template_name ?
                                        // <a href={actionData.whatsapp_template.whatsapp_template_name ? `${window.location.origin}/channels/viewintegration/whatsapp/legacy/templateinfo?id=${getMetaIntegrationWhatsAppId(actionData.whatsapp_template.whatsapp_template_id)}&template_id=${actionData.whatsapp_template.whatsapp_template_id}` : ""} target='blank'>
                                        <a href={actionData.whatsapp_template.whatsapp_template_name ? `${window.location.origin}/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${getMetaIntegrationWhatsAppId(actionData.whatsapp_template.whatsapp_template_id)}&template_id=${actionData.whatsapp_template.whatsapp_template_id}` : ""} target='blank'>
                                            {actionData?.whatsapp_template?.whatsapp_template_display_name ?? actionData?.whatsapp_template?.whatsapp_template_name}
                                        </a>
                                        :
                                        `Please select a${isCarouselTemplateActionType(stepAction?.action_type?.action_type_name) ? ' carousel ' : isSendOrderDetailTemplateActionType(stepAction?.action_type?.action_type_name) ? ' send order detail ' : ' '}template`
                                    }
                                </Grid>
                                <Grid item>
                                    <ModeEditIcon sx={{ display: "flex", height: "16px", width: "16px", cursor: "pointer" }} onClick={() => {
                                        setFlagTemplatePopup(true);
                                        setTempNodesTemplate(nodes)
                                    }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            {flagTemplatePopup &&
                <GlobalPopUp
                    open={flagTemplatePopup}
                    onClose={() => {
                        setFlagTemplatePopup(false);
                        onChangeCurrentActiveNodeConfig(tempNodesTemplate, currentActiveNodeConfig, stepAction.chatbot_step_action_id, tempActionData,
                            {
                                updateType: "editExistingStepAction"
                            }
                        );
                    }}
                    flagBackdrop
                    paperMinWidth={flagSmallScreen ? "310px" : "85%"}
                    paperMaxwidth={flagSmallScreen ? "610px" : "85%"}
                    flagShowCloseIcon={true}
                    height={"100%"}
                    titlePadding='0'
                    handleClose={() => {
                        setFlagTemplatePopup(false)
                        onChangeCurrentActiveNodeConfig(tempNodesTemplate, currentActiveNodeConfig, stepAction.chatbot_step_action_id, tempActionData,
                            {
                                updateType: "editExistingStepAction"
                            }
                        );
                    }}
                >
                    <TemplateDetailsComponent actionData={actionData} stepAction={stepAction} setFlagTemplatePopup={setFlagTemplatePopup} />
                </GlobalPopUp>
            }
        </Grid>
    )
}

export default TemplateFormComponent
